import "../styles/StartButton.css";

const StartButton = ({ isHeader = false, isHome = false, openIntakeForm }) => {
  return (
    <button
      className={`startButton ${isHeader ? "startButton-header" : ""} ${
        isHome ? "startButton-home" : ""
      }`}
      onClick={(e) => {
        e.preventDefault();
        document
          .querySelector("#contact")
          ?.scrollIntoView({ behavior: "smooth" });
        openIntakeForm();
      }}
    >
      <a href="#contact" style={{ textDecoration: "none", color: "inherit" }}>
        Boek een afspraak
      </a>
    </button>
  );
};

export default StartButton;
